import { useRef } from "react";

/**
 * Tab "segmentate" del portale Family (stesso aspetto di `.family-segmented-control`).
 * Accessibili: role=tablist/tab, aria-selected, frecce/Home/End, focus gestito (roving tabindex).
 * Il contenuto va racchiuso in <TabPanel> con lo stesso `idPrefix` e `value`.
 */
export const tabDomId = (idPrefix, value) => `${idPrefix}-tab-${value}`;
export const panelDomId = (idPrefix, value) => `${idPrefix}-panel-${value}`;

export function SegmentedTabs({ tabs, value, onChange, idPrefix, ariaLabel, className = "" }) {
  const refs = useRef({});
  const move = (event, index) => {
    const keys = { ArrowRight: 1, ArrowLeft: -1, Home: "first", End: "last" };
    if (!(event.key in keys)) return;
    event.preventDefault();
    const step = keys[event.key];
    const next = step === "first" ? 0 : step === "last" ? tabs.length - 1 : (index + step + tabs.length) % tabs.length;
    onChange(tabs[next].value);
    refs.current[tabs[next].value]?.focus();
  };
  return (
    <div role="tablist" aria-label={ariaLabel} className={`family-segmented-control ${className}`} style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
      {tabs.map((tab, index) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            ref={(node) => { refs.current[tab.value] = node; }}
            type="button"
            role="tab"
            id={tabDomId(idPrefix, tab.value)}
            aria-selected={active}
            aria-controls={panelDomId(idPrefix, tab.value)}
            tabIndex={active ? 0 : -1}
            className={active ? "is-active" : ""}
            onClick={() => onChange(tab.value)}
            onKeyDown={(event) => move(event, index)}
          >
            {tab.label}
            {tab.badge ? <sup className="ml-1 rounded-full bg-rose-500 px-1 text-white">{tab.badge}</sup> : null}
          </button>
        );
      })}
    </div>
  );
}

export function TabPanel({ idPrefix, value, active, children, className = "" }) {
  if (active !== value) return null;
  return (
    <div role="tabpanel" id={panelDomId(idPrefix, value)} aria-labelledby={tabDomId(idPrefix, value)} className={className}>
      {children}
    </div>
  );
}
